/** Browser SHA-256 hex for Event operator PIN + salt (kiosk-grade, not password vault security). */

const encoder = new TextEncoder();

const bytesToHex = (buf: ArrayBuffer): string =>
  [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');

export async function sha256Hex(input: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(input));
  return bytesToHex(digest);
}

export function randomPinSalt(): string {
  const a = new Uint8Array(16);
  crypto.getRandomValues(a);
  return bytesToHex(a.buffer);
}

export async function hashEventOperatorPin(pin: string, salt: string): Promise<string> {
  return sha256Hex(`${salt}:${pin.trim()}`);
}

export async function verifyEventOperatorPin(
  pin: string,
  salt: string,
  expectedHash: string
): Promise<boolean> {
  if (!pin || !salt || !expectedHash) return false;
  const h = await hashEventOperatorPin(pin, salt);
  return h === expectedHash;
}
